<script>
export default {
	name: 'AqEmpty',
	props: {
		title: {
			type: String,
			required: true,
		},
		text: {
			type: String,
			default: '',
		},
		tone: {
			type: String,
			default: 'neutral',
		},
	},
}
</script>

<template>
	<div class="aq-empty" :class="`aq-empty--${tone}`">
		<span class="aq-empty__icon" aria-hidden="true">
			<svg v-if="tone === 'danger'" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
				<rect x="4" y="10" width="16" height="10" rx="2" />
				<path d="M8 10V7a4 4 0 018 0v3" />
			</svg>
			<svg v-else width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
				<path d="M4 7h16v12H4z" />
				<path d="M4 7l2-3h12l2 3M9 12h6" />
			</svg>
		</span>
		<strong class="aq-empty__title">{{ title }}</strong>
		<p v-if="text" class="aq-empty__text">{{ text }}</p>
		<div v-if="$slots.default" class="aq-empty__actions"><slot /></div>
	</div>
</template>

<style scoped>
.aq-empty {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 8px;
	padding: 40px 24px;
	text-align: center;
}
.aq-empty__icon {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 56px;
	height: 56px;
	margin-bottom: 6px;
	border-radius: 16px;
	background: var(--aq-primary-soft);
	color: var(--aq-primary);
}
.aq-empty--danger .aq-empty__icon {
	background: var(--aq-danger-soft);
	color: var(--aq-danger);
}
.aq-empty__title {
	font-size: 17px;
	color: var(--aq-ink);
}
.aq-empty__text {
	max-width: 460px;
	margin: 0;
	color: var(--aq-muted);
	font-size: 14px;
	line-height: 1.5;
}
.aq-empty__actions {
	display: flex;
	gap: 10px;
	margin-top: 10px;
}
</style>
